import clsx from "clsx";
import Styles from "./Pagination.module.scss";
import { useCallback, useMemo } from "react";
export default function PaginationComponent({ page, handleCallApi }) {
  const { next, previous, totalPages, pageIndex } = page;
  const currentPage = pageIndex + 1;

  const generatePages = useMemo(() => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage === 1) {
        return [1, 2, 3];
      } else if (currentPage === totalPages) {
        return [totalPages - 2, totalPages - 1, totalPages];
      } else {
        return [currentPage - 1, currentPage, currentPage + 1];
      }
    }
  }, [totalPages, currentPage]);

  const handleChosePage = useCallback(
    (value) => {
      handleCallApi(value - 1);
    },
    [handleCallApi]
  );

  const handlePrevAndNext = useCallback(
    (type) => {
      if (previous && type === "Prev") {
        handleCallApi(pageIndex - 1);
      } else if (next && type === "Next") {
        handleCallApi(pageIndex + 1);
      }
    },
    [handleCallApi, pageIndex, previous, next]
  );

  return (
    <div className={clsx(Styles.Pagination)}>
      {totalPages ? (
        <>
          <span
            onClick={() => handlePrevAndNext("Prev")}
            className={clsx(Styles.prev)}
            style={!previous ? { cursor: "not-allowed", color: "#cfccc6" } : {}}
          >
            Trước
          </span>

          {generatePages.map((pageNumber, index) => {
            if (pageNumber === "...") {
              return <span key={`ellipsis-${index}`}>...</span>;
            } else {
              return (
                <span
                  key={`page-${pageNumber}`}
                  onClick={() => handleChosePage(pageNumber)}
                  className={clsx(
                    Styles.item,
                    pageNumber === pageIndex + 1 ? Styles.active : "",
                    "mx-1"
                  )}
                >
                  {pageNumber}
                </span>
              );
            }
          })}

          <span
            onClick={() => handlePrevAndNext("Next")}
            className={clsx(Styles.last)}
            style={!next ? { cursor: "not-allowed", color: "#cfccc6" } : {}}
          >
            Sau
          </span>
        </>
      ) : (
        ""
      )}
    </div>
  );
}
